"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffChangesFromArtifact = void 0;
const lodash_1 = require("lodash");
const diffChangesFromArtifact = (original, changed, excludeFields = ["createdAt", "updatedAt"]) => {
    const oldFiltered = (0, lodash_1.omit)(original, excludeFields);
    const newFiltered = (0, lodash_1.omit)(changed, excludeFields);
    const changedOld = {};
    const changedNew = {};
    const allKeys = new Set([
        ...Object.keys(oldFiltered),
        ...Object.keys(newFiltered),
    ]);
    for (const key of allKeys) {
        const oldValue = oldFiltered[key];
        const newValue = newFiltered[key];
        if (!(0, lodash_1.isEqual)(oldValue, newValue)) {
            changedOld[key] = oldValue;
            changedNew[key] = newValue;
        }
    }
    // strip undefined values from changedNew
    for (const key of Object.keys(changedNew)) {
        if (changedNew[key] === undefined) {
            delete changedNew[key];
        }
    }
    const changedOldFiltered = (0, lodash_1.pick)(changedOld, Object.keys(changedNew));
    return { old: changedOldFiltered, new: changedNew };
};
exports.diffChangesFromArtifact = diffChangesFromArtifact;
//# sourceMappingURL=diffChangesFromArtifact.js.map